import { IconCopy, IconEye, IconEyeOff } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Group, ITextProps, Icon, Text } from '@zorro/web/design-system';
import { ReactNode, useState } from 'react';

import { CopyToClipboard } from '../CopyToClipboard';

export type SensitiveValueProps = {
  value: string | ReactNode;
  isSensitive?: boolean;
  isMasked?: boolean;
  copyValue?: string | null;
  size?: ITextProps['size'];
  onReveal?: () => void;
};

export const SensitiveValue = ({
  value,
  isSensitive = false,
  isMasked,
  copyValue,
  size,
  onReveal,
}: SensitiveValueProps) => {
  const [isHidden, setIsHidden] = useState<boolean>(true);

  const handleToggle = () => {
    if (isHidden) {
      onReveal?.();
    }
    setIsHidden((prev) => !prev);
  };

  return (
    <Group gap="xxs">
      <Text
        size={size}
        style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
        isMasked={isMasked}
      >
        {isSensitive && isHidden ? '*********' : value}
      </Text>
      {isSensitive && (
        <ActionIcon size="sm" onClick={handleToggle}>
          <Icon
            icon={isHidden ? IconEye : IconEyeOff}
            color="var(--brand-grayscale-600)"
            width={12}
          />
        </ActionIcon>
      )}
      {copyValue && (
        <CopyToClipboard text={copyValue}>
          <ActionIcon size="sm">
            <IconCopy
              size={12}
              cursor="pointer"
              color="var(--brand-grayscale-600)"
            />
          </ActionIcon>
        </CopyToClipboard>
      )}
    </Group>
  );
};
